import { css } from "@emotion/react";
import React from "react";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";
import { CSS_MQ } from "../../styles/breakpoints";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

export const NewsletterHeadlineWithParagraph: React.FC<{
  headline: TranslatedValue;
  paragraph: TranslatedValue;
}> = ({ headline, paragraph }) => {
  return (
    <>
      <span
        css={[
          fontColor.black,
          FONTS.SwarovskiFutura500,
          fontSize.x3,
          css`
            text-align: center;
            text-transform: uppercase;

            margin-bottom: 12px;
            ${CSS_MQ.atLeastLg} {
              margin-top: 30px;
              margin-bottom: 30px;
            }

            display: block;
          `,
        ]}
      >
        <T>{headline}</T>
      </span>

      <p
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x25,
          css`
            line-height: calc(24 / 18);

            margin-top: 0;
            margin-bottom: 20px;
          `,
        ]}
      >
        <T>{paragraph}</T>
      </p>
    </>
  );
};
